<template>
    <div class="other-files">
        <div class="main-form">
            <div class="main-form-title">绣花附件上传</div>
            <Upload
                :action="upload_url"
                :data="{ dir: 'template' }"
                :before-upload="(file)=>onBeforeUpload2(file,'xh')"
                :show-upload-list="false"
                multiple
            >
                <div class="btn-other mt-40">
                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                    上传文件
                </div>
            </Upload>
            <div class="other-file-list mt-40">
                <div class="file-item-box" v-for="(v, k) in form_data.other_file.filter((item)=>{
                    return item.type == 'xh';
                })" :key="`of` + k" >
                    <a :href="v.path" class="file-item" target="_blank">
                        <img :src="util.get_image_icon(v.name)" class="icon-doc" />
                        {{ v.name }}
                    </a>
                    <img class="icon-del cursor" src="@/assets/images/design/icon-del.png" @click.prevent="del_other_file(v)" alt="">
                </div>
            </div>
            <div class="main-form-title">印花附件上传</div>
            <Upload
                :action="upload_url"
                :data="{ dir: 'template' }"
                :before-upload="(file)=>onBeforeUpload2(file,'yh')"
                :show-upload-list="false"
                multiple
            >
                <div class="btn-other mt-40">
                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                    上传文件
                </div>
            </Upload>
            <div class="other-file-list mt-40">
                <div class="file-item-box" v-for="(v, k) in form_data.other_file.filter((item)=>{
                    return item.type === 'yh';
                })" :key="`of` + k" >
                    <a :href="v.path" class="file-item" target="_blank">
                        <img :src="util.get_image_icon(v.name)" class="icon-doc" />
                        {{ v.name }}
                    </a>
                    <img class="icon-del cursor" src="@/assets/images/design/icon-del.png" @click.prevent="del_other_file(v)" alt="">
                </div>
            </div>
            <div class="main-form-title">其它附件上传</div>
            <Upload
                :action="upload_url"
                :data="{ dir: 'template' }"
                :before-upload="(file)=>onBeforeUpload2(file)"
                :show-upload-list="false"
                multiple
            >
                <div class="btn-other mt-40">
                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                    上传文件
                </div>
            </Upload>
            <div class="other-file-list mt-40">
                <div class="file-item-box" v-for="(v, k) in form_data.other_file.filter((item)=>{
                    return !['yh','xh'].includes(item.type) || !item.type;
                })" :key="`of` + k" >
                    <a :href="v.path" class="file-item" target="_blank">
                        <img :src="util.get_image_icon(v.name)" class="icon-doc" />
                        {{ v.name }}
                    </a>
                    <img class="icon-del cursor" src="@/assets/images/design/icon-del.png" @click.prevent="del_other_file(v)" alt="">
                </div>
            </div>
        </div>
        <div class="main-content">
            <Lesson></Lesson>
        </div>
    </div>
</template>
<script>
import { uploadFileToOSS } from "@/utils/oss";
import util from '@/utils/util';
import { mapState } from 'vuex';
import Lesson from "./Lesson.vue";
    export default {
        name: "Other",
        data() {
            return {
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                util: util,
                uploading: false,
                uploadQueue:[],
                debounceTimer: null, // 防抖定时器
                debounceTime: 300, // 防抖时间（毫秒）
            }
        },
        components: {
            Lesson
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
            }),
        },
        mounted() {
            //防止在点开弹窗以后直接刷新页面导致再次进入弹窗不关闭的问题
            this.$store.commit('design/hide_lesson_popup');
        },
        methods: {
            input($event, field, k) {
                let object = this.form_data[field][k]
                object.content = $event.target.value
                this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
            },
            onBeforeUpload(file, field, k, child_field) {
                uploadFileToOSS(file, 'template').then(url => {
                    let object = this.form_data[field][k]
                    if (child_field === "file") {
                        object.raw = url;
                        object.raw_name = file.name;
                    } else if (child_field === "image") {
                        object.image = url;
                    }
                    this.$store.commit('design/arr_update_one', {key: field, index: k, value: object})
                })
                return false;
            },
            add_trademark() {
                let object = {image: "", content: "", raw: "", raw_name: "",}
                this.$store.commit("design/arr_push_one", {key: 'trademark', value: object})
            },
            del_trademark(k) {
                this.$store.commit('design/arr_remove_one', {key: 'trademark', index: k})
            },
            add_label() {
                let object = {image: "", content: "", raw: "", raw_name: "",}
                this.$store.commit("design/arr_push_one", {key: 'label', value: object})
            },
            del_label(k) {
                this.$store.commit('design/arr_remove_one', {key: 'label', index: k})
            },
            input_other(e) {
                this.$store.commit('design/update_common', {key: 'other_remark', value: e.target.value})
            },
            del_other_file(file) {
                const index = this.form_data.other_file.findIndex(item => item.path === file.path)
                if (index !== -1) {
                    this.$store.commit('design/arr_remove_one', {key: 'other_file', index: index})
                }
            },
            onBeforeUpload2(file,type='qt') {
                if(this.form_data.other_file.length >= 10) {
                    this.$layer.msg(`最多可添加10个文件`)
                    return
                }
                this.uploading = true;
                // 将文件加入队列
                file.ftype = type;
                this.uploadQueue.push(file);

                // 清除旧定时器
                if (this.debounceTimer) {
                    clearTimeout(this.debounceTimer);
                }

                // 设置新定时器：如果一段时间内没有新文件进来，则认为上传完成
                this.debounceTimer = setTimeout(() => {
                    this.processAllFiles();
                }, this.debounceTime);
                return false;
                // uploadFileToOSS(file, 'template').then(url => {
                //     let object = { name: file.name, path: url }
                //     this.$store.commit('design/arr_push_one', {key: 'other_file', value: object})
                // })
            },
            async processAllFiles() {
                const queue = [...this.uploadQueue];
                this.uploadQueue = []; // 清空队列

                console.log(`Startting upload ${queue.length} files...`);

                for (const file of queue) {
                    try {
                        const url = await uploadFileToOSS(file, "template");
                        let object = { name: file.name, path: url ,type:file.ftype}
                        console.log('object--->',object);
                        this.$store.commit('design/arr_push_one', {key: 'other_file', value: object})
                    } catch (err) {
                    this.$layer.msg(`上传失败：${file.name}`);
                    }
                }
                console.log('this.form_data',this.form_data.other_file);
            },
        },
    }
</script>
<style lang="scss" scoped>
.other-files{
    width: 100%;
    height: 100%;
    display: flex;
    column-gap: 30px;
    .main-form{
        width: 488px;
        height: 100%;
        overflow-y: auto;
        padding: 30px;
        background: #fff;
        border-right: 1px solid #f0f0f0;
        &::-webkit-scrollbar {
            display: none;
        }
        .main-form-title {
            color: #000;
            font-size: 18px;
            display: flex;
            align-items: center;
            column-gap: 10px;
            line-height: 18px;
            font-weight: bold;
            &::before {
                content: "";
                width: 2px;
                height: 18px;
                line-height: 18px;
                background: #000;
            }
        }
        .btn-other{
            width:100%;
            height:56px;
            display:flex;
            justify-content:center;
            align-items:center;
            column-gap:10px;
            background:#fff;
            border:1px solid #b3b3b3;
            border-radius:5px;
            color:#1d1d1d;
            font-size:14px;
            cursor:pointer;
            .icon{
                width:24px;
                height:24px;
            }
        }
        .other-file-list{
            display:flex;
            flex-direction:column;
            row-gap:10px;
            .file-item-box{
                display:flex;
                align-items:center;
                justify-content:space-between;
                background:#f3f3f3;
                width:100%;
                height:52px;
                padding:0 15px;
                .file-item{
                    display:flex;
                    align-items:center;
                    height:100%;
                    column-gap:10px;
                    color: #1a1a1a;
                    font-size: 12px;
                    .icon-doc{
                        width:32px;
                        height:32px;
                    }
                }
                .icon-del{
                    width:20px;
                    height:20px;
                    cursor:pointer;
                }
            }
        }
    }
    .main-content{
        // flex: 1 0 1000px;
        flex:1;
        height: 100%;
        min-height: 0;
        padding: 30px 10% 30px 0;
        display:flex;
        align-items:center;
        justify-content:center;
    }
}

.mt-40 {
    margin-top: 40px;
}

::v-deep .ivu-upload{
    width:100%;
}
</style>